import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BannersComponent } from './banners/banners-message.component';

@NgModule({
  imports: [CommonModule],
  exports: [BannersComponent],
  declarations: [BannersComponent],
})
export class BannerMessageModule {}
